import { define, ui } from '@owenscorning/pcb.alpha';

export default define`Blog Next Steps`('0.0.1')({
  gutterless: true,
  view: () => (
    <UI.Modules.Page.Reusable
      value={{ path: 'roofing', name: 'Blog Next Steps' }}
    />
  ),
  edit: {},
});
